package ru.it_mozaika.sender.js.application.components


import emotion.react.css
import io.ktor.client.call.*
import kotlinx.css.img
import mui.material.Box
import mui.material.ButtonBase
import mui.material.Typography
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.Breakpoint
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.img
import react.useEffectOnce
import react.useState
import ru.it_mozaika.components.AvatarButton
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.context.useUser
import web.cssom.*
external interface HeaderProps : Props {
    var onLeftDrawerToggle: () -> Unit
}
val Header = FC<HeaderProps> { props ->
    val theme = useTheme<Theme>()
    val logout = useUser().logout
    val currentUser = useUser().currentUser
    var dbName by useState("")
    fun getDbName(){
        Http.get(
            "/system/db",
            mapOf()
        ) { response ->
            dbName = response.body<String>()
        }
    }
    useEffectOnce{
        getDbName()
    }
    Box {
        sx {
            width = 228.px
            display = Display.flex
            (theme.breakpoints.down(Breakpoint.md)) {
                width = Auto.auto
            }
        }

        Box {
            component = ReactHTML.span
            sx {
                display = responsive(Breakpoint.xs to None.none, Breakpoint.md to Display.block)
                flexGrow = number(1.0)
            }
            ButtonBase {
                disableRipple = true
                img {
                    src = "/assets/img/Taras-RocketLogo1.png"
                    css {
                        maxHeight = 64.px
                        paddingLeft = 14.px
                        paddingBottom = 14.px
                    }
                }
            }
        }
        AvatarButton {
            this.onClick = { props.onLeftDrawerToggle() }
            mui.icons.material.Menu {
                sx {
                    fontSize = 1.3.rem
                }
                stroke = "1.5"
            }
        }
    }

    Box {
        sx {
            flexGrow = number(1.0)
            height = 52.px
        }
    }
    Box { sx { flexGrow = number(1.0) }

        if (currentUser?.role == UserRole.Admin) {
            Typography {
                variant = TypographyVariant.h1
                sx {
                    color = Color("red")
                }
                +"ИСПОЛЬЗУЕТСЯ $dbName!!"
            }
        }
    }
    Box { sx { flexGrow = number(1.0) } }
    Box {
        AvatarButton {
            this.onClick = { logout() }
            mui.icons.material.Logout {
                sx {
                    fontSize = 1.3.rem
                }
                stroke = "1.5"
            }
        }
    }
}

